import React from 'react';
import { createUseStyles } from 'react-jss';
import { Theme } from '@app/theme';
import { Participation } from '@app/api';
import { EmptyState } from './EmptyState';
import Gift from '@app/illu/Small/Gift.svg';
import { StudiesCardContainer } from './StudiesCardContainer';
import { PastParticipationCard } from './PastParticipationCard';
import { useTranslation } from 'react-i18next';

const useStyles = createUseStyles((theme: Theme) => ({
  cardContainer: {
    width: '100%',
    maxWidth: theme.maxContentWidth.reduced,
    minWidth: 'auto',
    overflow: 'hidden',
    borderRadius: theme.borderRadius.large,
    marginBottom: theme.marginBase,
    [theme.media.homeScreen]: {
      width: '100%',
      minWidth: 'auto',
    },
  },
}));

interface Props {
  participations: Participation[];
}

export const StudiesPast = ({ participations }: Props) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const noParticipation = !participations || participations.length === 0;

  return (
    <StudiesCardContainer noParticipation={noParticipation}>
      {noParticipation ? (
        <EmptyState
          illustration={Gift}
          alt="Gift"
          title={t('studies.empty.past.title')}
          description={t('studies.empty.past.description')}
        />
      ) : (
        participations.map((participation, num) => {
          return (
            <PastParticipationCard
              key={participation.id}
              participation={participation}
              className={classes.cardContainer}
              variant={num === 0 ? 'plain' : 'transparent'}
            />
          );
        })
      )}
    </StudiesCardContainer>
  );
};
